import React from "react";
import { formatSubscriptionDate } from "../utils/premiumHelpers";

export default function PremiumBadge({
  isPremium,
  subscriptionEndDate,
  variant = "small", // 'small' | 'medium' | 'large'
  showExpiry = false,
}) {
  if (!isPremium) return null;

  const sizeClasses = {
    small: "px-2 py-1 text-xs",
    medium: "px-3 py-1 text-sm",
    large: "px-4 py-2 text-base",
  };

  const iconSizeClasses = {
    small: "w-3 h-3",
    medium: "w-4 h-4",
    large: "w-5 h-5",
  };

  if (variant === "large") {
    return (
      <div className="flex items-center gap-3 bg-gradient-to-r from-yellow-400 to-yellow-500 text-yellow-900 rounded-lg p-4 mb-4">
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
        <div>
          <p className="font-bold text-lg">Premium Member</p>
          {showExpiry && subscriptionEndDate && (
            <p className="text-sm opacity-90">Expires: {formatSubscriptionDate(subscriptionEndDate)}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`inline-flex items-center gap-1 bg-yellow-400 dark:bg-yellow-500 text-yellow-900 dark:text-yellow-900 rounded-full font-bold ${sizeClasses[variant]} hover:shadow-md transition`}
      title={showExpiry && subscriptionEndDate ? `Expires: ${formatSubscriptionDate(subscriptionEndDate)}` : "Premium Member"}
    >
      <svg className={`${iconSizeClasses[variant]}`} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
      <span>Premium</span>
    </div>
  );
}
